import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Tag } from "ui/Tag"

// Crew blackouts set by the guide/admin are listed with the member's own time off
export const isBlackout = (record) => record?.entry_type === "blackout"

const EntryTypeTag = ({ entryType }) => {
  const { t } = useTranslation()

  return entryType === "blackout" ? (
    <Tag type="warning">{t("crewMember.scheduledTimeOff.table.entryTypes.blackout")}</Tag>
  ) : (
    <Tag>{t("crewMember.scheduledTimeOff.table.entryTypes.timeOff")}</Tag>
  )
}

EntryTypeTag.propTypes = {
  entryType: PropTypes.string
}

export default EntryTypeTag
